import styled from "@emotion/styled/macro";
import { views } from "../../../common/styles/theme.styles";

export const ConciergeRightPaneWrapper = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #000;

  ${views.desktop} {
    display: flex;
    width: 40%;
  }
`;

export const ConciergeRightPaneImage = styled.img`
  max-width: 100%;
  max-height: 473px;
  display: block;
  object-fit: contain;
  margin-left: auto;
`;

export const ConciergeRightPaneTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 98px;
  gap: 60px;
`;

export const ConciergeRightPaneText = styled.div`
text-align: center;
font-family: Domine;
font-size: 32px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #fff;
padding-inline: 32px;
`;

